/**
 * Event type ids shared across plan, tracking and user-list APIs.
 *
 * This UUID is currently also inlined at `UserListDashboard.jsx:158`,
 * `AnalyticsDashboard.js:396`, `HomeDashboard.js:39`, `CopyWorkoutPlanModal.jsx:6`
 * and `CopyMealOptionToClientPlanModal.jsx:10`. New code should import it from
 * here; those call sites are left alone to keep this change reviewable.
 */
export const USER_LIST_EVENT_TYPE_ID = "4850387a-8838-45d5-8c65-dce9d1f86de6";
